import React from 'react';

const ServiceBookNowTrigger = (props: JSX.IntrinsicAttributes) => <div id="service-book-now-trigger" {...props} />;
// eslint-disable-next-line react/display-name
export default ServiceBookNowTrigger;
